<section class="app-user-view p-1">
  <h6>
    <strong>{{ currentPlan?.name }}</strong>
  </h6>
  <div class="card user-card p-1" *ngFor="let provisioning of provisionings">
    <div class="user-info-wrapper justify-content-between">
      <div class="d-flex justify-content-between">
        <product-icon
          [type]="provisioning.product.send_type"
          [badge]="true"
        ></product-icon>
        <span class="ml-2">{{ provisioning.product.name }}</span>
      </div>

      <div class="d-flex flex-wrap justify-content-between">
        <div class="user-info-title">
          <span class="card-text user-info-title font-weight-bold mb-0"
            >Cantidad</span
          >
        </div>
        <div
          class="badge"
          [ngClass]="
            'badge-light-' + productStyle[provisioning.product.send_type].color
          "
        >
          <i
            *ngIf="
              provisioning.has_extra_messages &&
                provisioning.has_extra_unlimited;
              else noLimited
            "
            ngbTooltip="Ilimitado"
            class="fa-solid fa-infinity"
          ></i>

          <ng-template #noLimited>
            <span
              class="card-text mb-0"
              *ngIf="!provisioning.has_extra_messages"
            >
              {{ provisioning.total_messages | number }}
            </span>
            <span
              class="card-text mb-0"
              ngbTooltip="Incluye mensajes extras"
              *ngIf="provisioning.has_extra_messages"
            >
              {{
                provisioning.total_messages + provisioning.extra_total_messages
                  | number
              }}
            </span>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</section>
